import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

const editConsultationCharges = createAsyncThunk('editConsultationCharges', async (body:any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = BILLING_ROUTES.CONSULTATION_CHARGES.edit;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error('Failed to fetch Billing Details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });

export default editConsultationCharges;
